function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';

var Fixed = function (_React$PureComponent) {
  _inherits(Fixed, _React$PureComponent);

  function Fixed() {
    _classCallCheck(this, Fixed);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Fixed.prototype.render = function render() {
    return React.createElement(
      'div',
      { style: { position: 'fixed' }, className: 'fixed' },
      this.props.children
    );
  };

  return Fixed;
}(React.PureComponent);

Fixed._idyll = {
  name: "Fixed",
  tagType: "open"
};

export default Fixed;